import { sharedProperty, useUrlParams } from '../../hooks';
import * as yup from "yup";
import { Formik } from "formik";
import { Col, Form, Row, Container } from 'react-bootstrap';
import { Button, FormSectionHeader, HandleDropDownListChange, SearchableServiceTypeDropdown } from '../../components';
import { ProviderAddAllServicesRequest } from '../../models';

interface ProviderAddAllServicesPageProps {
  showState: sharedProperty<boolean>;
  providerId: number;
  onSubmit: any;
}

export function ProviderAddAllServicesPage(props: Readonly<ProviderAddAllServicesPageProps>) {

  const validationSchema = yup.object().shape({
    providerId: yup.number().required("Provider is required"),
    serviceTypeId: yup.number()
      .required("Service Type is required")
      .test("is-valid-service-type", "Please select a service type", (value) => value > 0),
  });

  const locationId = parseInt(useUrlParams("id"))

  return (
    <Formik
        validationSchema={validationSchema}
        initialValues={{
          serviceTypeId: 0,
          providerId: props.providerId,
        }}
        onSubmit={async (values) => {
          props.onSubmit({
            ...values,
            locationId: locationId,
            id: 0
          } as ProviderAddAllServicesRequest);
        }}
      >
        {({values, touched, errors, setFieldValue, handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit} className="h-100 d-flex flex-column justify-content-between py-3">
              <Container className="px-3">
                {/* Service type */}
                <FormSectionHeader>Service Type</FormSectionHeader>
                <Row>
                  <Col>
                    <Form.Group controlId="serviceTypeId">
                        <SearchableServiceTypeDropdown
                          name="serviceTypeId"
                          value={values.serviceTypeId}
                          placeholder="Service Type"
                          onChange={(e) => HandleDropDownListChange(e, setFieldValue)}
                          isInvalid={touched.serviceTypeId && !!errors.serviceTypeId}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.serviceTypeId}
                        </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <p className="small text-body-secondary mb-0">
                  Every service in the selected type will be added to this
                  provider using the service default durations.
                </p>
              </Container>

              <Container className="pt-3 border-top">
                <Row className="g-0">
                  <div className="col-12 pe-2">
                    <Button onClick={() => { props.showState.setter(false) }} variant="cancel" className="w-100">
                      Cancel
                    </Button>
                  </div>
                  <div className="col-12 ps-2">
                    <Button type='submit' variant="primary" className="w-100">
                      Save
                    </Button>
                  </div>
                </Row>
              </Container>
            </Form>
          )
        }}
      </Formik>
  )
}

export default ProviderAddAllServicesPage;
